<ng-template #search>
  <div class="search-container" [class.show]="searchFilterOpen">
    <div class="search-field">
      <form class="search-form" (submit)="addFilter(filterType, searchInput.value)">
        <input #searchInput id="{{filterType}}" type="search" class="search-input"
          fiTranslation="SEARCH_PLACEHOLDER" [isPLaceHolder]="true" value="">
      </form>
    </div>
    @if (searchInput.value) {
      <div class="clear-input">
        <img alt="Close" src="/assets/icons/close-icon.svg" (click)="searchInput.value = ''">
      </div>
    }
  </div>
</ng-template>

<ng-template #multiselect>
  <div fiCustomSelect (value)="onMultiselectChanged($event)" [data]="multiselectOptions" [isMultiSelect]="true"
    [selectedData]="multiselectSelectedOptions" [dataValueKey]="'Id'" [dataNameKey]="multiselectNameKey"
    [translate]="filterType === 'PREMIUM_PROJECT_CUSTOMER' || filterType === 'DEADLINE_STATUS'"
    class="multiselect-container select-type select input-field" id="{{filterType}}">
    <span class="selected-value placeholder"></span>
    <div class="options-cont large">
      <ul class="options"></ul>
      @if (!multiSelectDataLoaded) {
        <mat-spinner class="select-loader" [diameter]="14"></mat-spinner>
      }
    </div>
  </div>
</ng-template>

<table class="overview-table" [class.empty]="!contactLeads?.length">
  <colgroup>
  <col class="compact-table-col select-col">
  <col class="compact-table-col type-col">
  <col class="compact-table-col address-col">
  <col class="compact-table-col contact-col">
  <col class="compact-table-col created-date-col">
  <col class="compact-table-col country-col">
  <col class="compact-table-col status-col">
  <col class="compact-table-col responsible-col">
  <col class="compact-table-col due-date-col">
  <col class="compact-table-col action-col">
</colgroup>
<thead>
  <tr class="overview-table-head-row" [class.empty]="!contactLeads?.length">

    <td class="compact-table-col select-col">
      <fi-checkbox [checked]="checkedAll" class="toggle-btn"
      (checkedChange)="checkAllFields(!checkedAll)"></fi-checkbox>
    </td>

    <td class="compact-table-col type-col" [class.is-sorted]="filters.sortType === 'TYPE'">
      <div class="line">
        <span fiTranslation="REQUEST_OVERVIEW_COLUMNS_HEADLINE_LEAD_TYPE"
        (click)="sortByColumn('TYPE')"></span>
        <img class="filter-img" src="assets/icons/filter-dark.svg" alt="filter"
          (click)="openMultiselectFilter('TYPE')">
      </div>

      @if (filterType === 'TYPE' && showFilterSelectBox) {
        <ng-container *ngTemplateOutlet="multiselect"></ng-container>
      }
    </td>

    <td class="compact-table-col address-col"
      [class.is-sorted]="filters.sortType === 'COMMISSION'">
      <div class="line">
        <span fiTranslation="REQUEST_OVERVIEW_COLUMNS_HEADLINE_PROJECT"
        (click)="sortByColumn('COMMISSION')"></span>
        <img class="search-img" src="assets/icons/search-dark.svg" alt="search"
          (click)="openSearchFilter('COMMISSION')">
      </div>

      @if (filterType === 'COMMISSION') {
        <ng-container *ngTemplateOutlet="search"></ng-container>
      }
    </td>

    <td class="compact-table-col contact-col" [class.is-sorted]="filters.sortType === 'CONTACT'">
      <div class="line">
        <span fiTranslation="REQUEST_OVERVIEW_COLUMNS_HEADLINE_CONTACT"
        (click)="sortByColumn('CONTACT')"></span>
        <img class="search-img" src="assets/icons/search-dark.svg" alt="search"
          (click)="openSearchFilter('CONTACT_SEARCH')">
        <img class="filter-img" src="assets/icons/filter-dark.svg" alt="filter"
          (click)="openMultiselectFilter('CONTACT_MULTISELECT')">
      </div>

      @if (filterType === 'CONTACT_SEARCH') {
        <ng-container *ngTemplateOutlet="search"></ng-container>
      }

      @if (filterType === 'CONTACT_MULTISELECT' && showFilterSelectBox) {
        <ng-container *ngTemplateOutlet="multiselect"></ng-container>
      }
    </td>

    <td class="compact-table-col created-date-col" [class.is-sorted]="filters.sortType === 'DATE2'">
      <div class="line">
        <span fiTranslation="SEARCH_DATE" (click)="sortByColumn('DATE2')"></span>
      </div>
    </td>

    <td class="compact-table-col country-col" [class.is-sorted]="filters.sortType === 'LAND'">
      <div class="line">
        <span fiTranslation="REQUEST_OVERVIEW_COLUMNS_HEADLINE_COUNTRY"
        (click)="sortByColumn('LAND')"></span>
        <img class="filter-img" src="assets/icons/filter-dark.svg" alt="filter"
          (click)="openMultiselectFilter('LAND')">
      </div>

      @if (filterType === 'LAND' && showFilterSelectBox) {
        <ng-container *ngTemplateOutlet="multiselect"></ng-container>
      }
    </td>

    <td class="compact-table-col status-col" [class.is-sorted]="filters.sortType === 'STATUS'">
      <div class="line">
        <span fiTranslation="REQUEST_OVERVIEW_COLUMNS_HEADLINE_STATUS"
        (click)="sortByColumn('STATUS')"></span>
        <img class="filter-img" src="assets/icons/filter-dark.svg" alt="filter"
          (click)="openMultiselectFilter('STATUS')">
      </div>

      @if (filterType === 'STATUS' && showFilterSelectBox) {
        <ng-container *ngTemplateOutlet="multiselect"></ng-container>
      }
    </td>

    <td class="compact-table-col responsible-col" [class.is-sorted]="filters.sortType === 'RESPONSIBLE'">
      <div class="line">
        <span fiTranslation="REQUEST_OVERVIEW_COLUMNS_HEADLINE_RESPONSIBLE"
        (click)="sortByColumn('RESPONSIBLE')"></span>
        <img class="search-img" src="assets/icons/search-dark.svg" alt="search"
          (click)="openSearchFilter('RESPONSIBLE')">
        @if (isFinstralUser) {
          <img class="filter-img" src="assets/icons/filter-dark.svg" alt="filter"
            (click)="openMultiselectFilter('PREMIUM_PROJECT_CUSTOMER')">
        }
      </div>

      @if (filterType === 'RESPONSIBLE') {
        <ng-container *ngTemplateOutlet="search"></ng-container>
      }
      @if (filterType === 'PREMIUM_PROJECT_CUSTOMER' && showFilterSelectBox) {
        <ng-container *ngTemplateOutlet="multiselect"></ng-container>
      }
    </td>

    <td class="compact-table-col due-date-col" [class.is-sorted]="filters.sortType === 'DATE'">
      <div class="line">
        <span fiTranslation="REQUEST_OVERVIEW_COLUMNS_HEADLINE_DUE_DATE"
        (click)="sortByColumn('DATE')"></span>
        <img class="filter-img" src="assets/icons/filter-dark.svg" alt="filter"
          (click)="openMultiselectFilter('DEADLINE_STATUS')">
      </div>

      @if (filterType === 'DEADLINE_STATUS' && showFilterSelectBox) {
        <ng-container *ngTemplateOutlet="multiselect"></ng-container>
      }
    </td>

    <td class="compact-table-col action-col">
      <div class="line">
        @if (!filters.closedLeads || filters.openLeads) {
          <span
          fiTranslation="REQUEST_OVERVIEW_COLUMNS_HEADLINE_NEXT_STEP"></span>
        }
      </div>
    </td>


  </tr>
</thead>

<tbody>
  @for (lead of contactLeads; track trackByLeadId(i, lead); let i = $index) {
    @if (lead.requiresConfirmation) {
      <tr [class.dense]="compactView$ | async" class="compact-row duplicate">
        <td colspan="1" class="compact-table-col"></td>
        <td [attr.colspan]="getDuplicateColspan()" class="compact-table-col">
          <div class="duplicate-content">
            <div class="duplicate-text">
              <span fiTranslation="REQUEST_CREATE_CONTACT_HEADLINE_NEW_REQUEST"></span>&nbsp;<span
              fiMaskSearched="{{ lead.Lead.DateFormattedId }}"
            [categoryName]="'Number'">{{ lead.Lead.DateFormattedId }}</span> - <span
          fiTranslation="ACTION_LEAD_FORWARD_OTHER_MANDANT_TEXT"></span>
        </div>
      </div>
    </td>
    <td [attr.colspan]="getDuplicateColspan(true)" class="compact-table-col">
      <div class="duplicate-content">
        <button [class.dense]="compactView$ | async" class="f_requires-confirmation-reject reject btn"
          (click)="rejectAssignment(i)" fiTranslation="REQUEST_OVERVIEW_ACTION_DECLINE_ENQUIRY">
        </button>
        <button [class.dense]="compactView$ | async" class="f_requires-confirmation-accept accept btn"
          (click)="confirmAssignment(i)" fiTranslation="REQUEST_OVERVIEW_ACTION_ACCEPT_ENQUIRY">
        </button>
      </div>
    </td>
  </tr>
}
@if (!lead.requiresConfirmation) {
  <tr class="compact-row"
    [class.active]="i === activeIndex"
    [class.dense]="compactView$ | async"
    [class.unread]="!lead.Lead.Read"
    (click)="lead.isDuplicate ? onDuplicateClick(i) : openLeadDetails(lead.Lead.Id, $event.ctrlKey)"
    >
    <td class="compact-table-col select-col">
      @if (!lead.isDuplicate) {
        <fi-checkbox [checked]="checkedLeads.has(lead.Lead.Id)" (click)=" $event.stopPropagation();"
          (checkedChange)="checkLead(lead);" class="toggle-btn"></fi-checkbox>
      }
    </td>
    <td class="compact-table-col type-col">
      <img [src]="leadHelper.getAssetImage(lead.Lead.LeadTypeId)"
        alt="file-type" #upload [isTitle]="true"
        [class.dense]="compactView$ | async"
        fiTranslation="{{titleHelper.getLeadTypeTranslation(lead.Lead.LeadTypeId)}}"
        matTooltip="{{ upload.dataset.matTooltip }}" matTooltipPosition="below"
        matTooltipClass='tooltip-style'>
    </td>
    <td class="compact-table-col address-col">
      @if ((compactView$ | async) && getAddress(lead, true).address) {
        <span #address [matTooltip]="isOverflown(address) ? address.textContent : ''"
          matTooltipPosition="below"
          matTooltipClass='tooltip-style overflow-4' (click)="openMapNewTab($event, lead);"
          fiMaskSearched="{{getAddress(lead, true).address}}"
          [categoryName]="getAddress(lead, true).isAddress ?  'Address' : 'Contact'"
          class="is-html-snippet">
          {{ getAddress(lead, true).address }}
        </span>
      }
      @if (!(compactView$ | async) && getAddress(lead, true).addresses) {
        @for (addr of getAddress(lead, true).addresses; track addr) {
          <span
            [class.one-line]="getAddress(lead, true).addresses.length > 1"
            [class.max-2-line]="getAddress(lead, true).addresses.length <= 1"
            #address [matTooltip]="isOverflown(address) ? address.textContent : ''"
            matTooltipPosition="below"
            matTooltipClass='tooltip-style overflow-4' (click)="openMapNewTab($event, lead);"
            fiMaskSearched="{{addr}}"
            [categoryName]="getAddress(lead, true).isAddress ?  'Address' : 'Contact'"
            class="is-html-snippet"
            [innerHTML]="addr">
          </span>
        }
      }
    </td>
    <td class="compact-table-col contact-col">
      @if (!lead.Lead.Contact?.Anonymized) {
        <span #contact [matTooltip]="isOverflown(contact) ? contact.textContent : ''"
          matTooltipPosition="below"
          matTooltipClass='tooltip-style overflow-4' class="contact-name"
          >
          <span fiMaskSearched="{{lead.Lead.Contact.FirstName}} {{lead.Lead.Contact.LastName}}"
          [categoryName]="'Contact'">{{ lead.Lead.Contact.FirstName }} {{ lead.Lead.Contact.LastName }}</span>
        </span>
      }
      @if (lead.ConnectedContacts?.length && !(compactView$ | async)) {
        <div
          (click)="setExpandedLeadLinkId(lead.Lead?.Id); $event.stopPropagation();"
          class="multiline-content linked-contacts"
          >
          @if (lead.ConnectedContacts?.length > 1 && expandedLeadLinkId !== lead.Lead?.Id) {
            <div
              #linkedContacts
              matTooltip="{{ isOverflown(linkedContacts) ? linkedContacts.textContent : ''}}"
              matTooltipPosition="below"
              matTooltipClass='tooltip-style overflow-4'
              >{{ lead.ConnectedContacts?.length }} <span
            fiTranslation="REQUEST_OVERVIEW_COLUMNS_HEADLINE_CONTACT_LINK"></span></div>
          }
          @if (lead.ConnectedContacts?.length <= 1 || expandedLeadLinkId === lead.Lead?.Id) {
            @for (contact of lead?.ConnectedContacts; track trackByIndex($index, contact)) {
              <div>{{ contact }}</div>
            }
          }
        </div>
      }
      @if (lead.Lead?.Contact?.Company && lead.Lead?.Contact?.ContactTypeId !== 3 && !(compactView$ | async)) {
        <div
          #company [matTooltip]="isOverflown(company) ? company.textContent : ''" matTooltipPosition="below"
          matTooltipClass='tooltip-style overflow-4'
          class="company-text"
          >
          {{ lead.Lead?.Contact?.Company }}
        </div>
      }
    </td>
    <td class="compact-table-col created-date-col">
      <span #date2 [fiMaskSearched]="getDate(lead)" [categoryName]="'Number'"
        matTooltip="{{ isOverflown(date2) ? date2.textContent : ''}}"
      matTooltipPosition="below" matTooltipClass='tooltip-style'>{{ getDate(lead) }}</span>
    </td>
    <td class="compact-table-col country-col">
      {{ lead?.Lead?.Address?.CountryCode ?? lead?.Lead?.Contact?.CountryCode }}
    </td>
    <td class="compact-table-col status-col">
      @if (lead.Lead.StatusText) {
        <span #status
          matTooltip="{{ isOverflown(status) ? lead.Lead.StatusText : ''}}"
          matTooltipPosition="below" matTooltipClass='tooltip-style overflow-4'>
          <span fiMaskSearched="{{lead.Lead.StatusText}}">{{ lead.Lead.StatusText }}</span>
        </span>
      }
    </td>
    <td class="compact-table-col responsible-col">
      <span #responsible matTooltip="{{ isOverflown(responsible) ? lead.Lead.EditorName : ''}}"
        matTooltipPosition="below"
        matTooltipClass='tooltip-style overflow-4'>
        <span fiMaskSearched="{{lead.Lead.EditorName}}"
          [categoryName]="'EditorName'">{{ lead.Lead.EditorName }}
        </span>
      </span>
      @if (lead.Lead.ExternalDesc && !(compactView$ | async)) {
        <div #externalDesc
          class="multiline-content"
          [class.show-top-left-arrow]="lead.Lead.ExternalEmail"
          [class.dont-show-top-left-arrow]="!lead.Lead.ExternalEmail"
          matTooltip="{{ isOverflown(externalDesc) ? lead.Lead.ExternalDesc : ''}}"
          matTooltipPosition="below"
          matTooltipClass='tooltip-style overflow-4'
          >{{ lead.Lead.ExternalDesc }}
        </div>
      }
    </td>
    <td class="compact-table-col due-date-col" [class.dense]="compactView$ | async">
      <fi-lead-status [leadData]="lead" [compactView]="true" [isOverview]="true"
        [dense]="compactView$ | async"
      [unread]="!lead.Lead.Read"></fi-lead-status>
    </td>
    <td class="compact-table-col action-col">
      <div class="line table-body-data" [style.height]="i === activeIndex ? activeCellHeight : ''"
        [class.our-user]="+lead.Lead.EditorId === +userId">
        @if (!lead.isDuplicate) {
          @if (!lead.Lead.Done && !lead?.IsAppointment && lead?.SuggestedAction) {
            <div
              (click)="openSuggestedActionPopup(i); $event.stopPropagation();">
              <img class="hide-on-smaller-screen action-image"
                matTooltipClass='tooltip-style overflow-5'
                matTooltipPosition="below"
                matTooltip="{{ lead.SuggestedAction?.Label }}"
                [class.dense]="compactView$ | async"
                [class.smaller]="['OFFER_SUBMIT'].includes(lead.SuggestedAction.Name)"
                [src]="actionHelper.getActionIconUrl(lead.SuggestedAction.Name,true, true)"
                alt="file-type">
              <span #suggestedAction class="hide-on-smaller-screen"
                matTooltip="{{ isOverflown(suggestedAction) ? lead.SuggestedAction?.Label : '' }}"
                matTooltipPosition="below"
              matTooltipClass='tooltip-style overflow-5'>{{ lead.SuggestedAction?.Label }}</span>
            </div>
          }
          @if (lead.IsAppointment && getAppointmentDate(lead)) {
            <span [class.unread]="!lead.Lead.Read"
              (click)='openLeadDetails(lead.Lead.Id, $event.ctrlKey)' class="hide-on-smaller-screen normal">
              {{ getAppointmentDate(lead) }}
            </span>
          }
          @if (!lead.Lead.Done) {
            <button [attr.data-action-index]="i" [class.active]="i === activeIndex"
              (click)="openActionPopup(i, $event);">
              <img alt="menu" src="assets/icons/dots-vertical.svg">
              <span class="u-hidden-visually" fiTranslation="ALT_TEXT_REQUEST_ADDITIONAL_ACTIONS"></span>
            </button>
          }
          @if (!lead.IsAppointment && lead.Lead.Done) {
            <span class="hide-on-smaller-screen" fiTranslation="REQUEST_OVERVIEW_DETAIL"></span>
            <img class="done-arrow hide-on-smaller-screen" alt="Arow right"
              src="/assets/icons/arrow-short.svg">
            }
          }
          @if (lead.isDuplicate) {
            <div (click)="onDuplicateClick(i); $event.stopPropagation();">
              <img class="hide-on-smaller-screen action-image"
                matTooltipClass='tooltip-style overflow-5'
                matTooltipPosition="below"
                matTooltip="{{ suggestedAction.innerText }}"
                [class.dense]="compactView$ | async"
                src="/assets/icons/duplicate.svg"
                alt="file-type">
              <span #suggestedAction class="hide-on-smaller-screen"
                matTooltip="{{ isOverflown(suggestedAction) ? suggestedAction.innerText : '' }}"
                matTooltipPosition="below"
              matTooltipClass='tooltip-style overflow-5' fiTranslation="ALT_TEXT_DUPLICATE_CHECK"></span>
            </div>
          }
        </div>
        <div class="compact-action-popup"
          [class.active]="i === activeIndex"
          [class.show-action]="showActions"
          [class.reverse]="contactLeads.length >= ((compactView$ | async) ? 20 : 10) && i >= contactLeads.length - ((compactView$ | async) ? 20 : 10)"
          >
          <fi-table-popup
            [externalEmail]="activeIndex > -1 ? contactLeads[activeIndex]?.Lead?.ExternalEmail : undefined"
            (closeModal)="closeOverlay(true)"
            (openLeadDetail)="openLeadDetails($event)"
            (openLeadDetailNewTab)="openLeadDetails($event, true)"
            (markAsUnread)="markAsUnread($event)"
            (markAsRead)="markAsRead($event)"
            [lead]="contactLeads[activeIndex]?.Lead"
            [read]="lead.Lead.Read"
            [suggestedAction]="lead.SuggestedAction"
            [isDuplicateLead]="lead.isDuplicate"
            [leadId]="i === activeIndex ? lead.Lead?.Id : null"
            (showActions)="setShowActions($event)"
            >
          </fi-table-popup>
        </div>
      </td>
    </tr>
  }
  @if (!lead.Lead.Read && !(compactView$ | async) && getLeadTakenMessage(lead)) {
    <tr class="compact-row"
      (click)="lead.isDuplicate ? onDuplicateClick(i) : openLeadDetails(lead.Lead.Id, $event.ctrlKey)"
      >
      <td colspan="10" class="compact-table-col no-overflow">
        <div class="change-contact-content">
          <img
            src="assets/icons/file-arrow-dark.svg"
            alt="file-type" class="td-body-icon"
            >
          <span
          fiTranslation="MESSAGE_SUBSEQUENT_ENQUIRY_TAKE_OVER"></span>&nbsp;{{ getLeadTakenMessage(lead).Date | date: 'dd.MM.yyyy HH:mm' }}&nbsp;<span
        fiTranslation="MESSAGE_SUBSEQUENT_ENQUIRY_TAKE_OVER_2"></span>&nbsp;{{ getLeadTakenMessage(lead).Sender.LastName }}
      </div>
    </td>
  </tr>
}
@if (!(compactView$ | async)  && !lead.Lead.RequiresConfirmation &&  lead.Lead.EditorId == userId && !lead.Lead.Read && (lead.Lead.LastAction === '_CONTACT_' || lead.Lead.LastAction === 'COMMENT_CREATE') && lead.Lead.LastEditorId != userId) {
  <tr class="compact-row"
    (click)="lead.isDuplicate ? onDuplicateClick(i) : openLeadDetails(lead.Lead.Id, $event.ctrlKey)"
    >
    <td colspan="10" class="compact-table-col no-overflow">
      <div class="change-contact-content">
        <img
          src="assets/icons/edit-blue.svg"
          alt="file-type" class="td-body-icon"
          >
        <span
        fiTranslation="MESSAGE_SUBSEQUENT_CHANGE_CONTACT"></span>&nbsp;{{ lead.Lead.LastChange | date: 'dd.MM.yyyy HH:mm' }}&nbsp;<span
      fiTranslation="MESSAGE_SUBSEQUENT_CHANGE_CONTACT_2"></span>&nbsp;{{ lead.Lead.LastEditorName }}
    </div>
  </td>
</tr>
}
@if (!(compactView$ | async)) {
  <tr class="compact-row"
    [ngStyle]="{display: searchAdditionaryComponent.isVisible(lead) ? '' : 'none'}">
    <td class="compact-table-col no-overflow" colspan="10">
      <fi-search-additionary [Lead]="lead"></fi-search-additionary>
    </td>
  </tr>
}
}

</tbody>

<tfoot>
  <tr>
    <td colspan="10">
      @if (leadsCount) {
        <div class="pagination-footer">
          <span fiTranslation="REQUEST_OVERVIEW_FILTER_PAGINATION_1"></span> &nbsp; ({{ visibleLeadsCount }}&nbsp;<span fiTranslation="REQUEST_OVERVIEW_FILTER_PAGINATION_2"></span>&nbsp;{{ leadsCount }})
          <button class="left-btn" [disabled]="(filters.pageNumber ?? 0) <= 0" (click)="prevPage()">
            <img src="assets/icons/pagination-arrow.svg" alt="left">
            <span class="u-hidden-visually" fiTranslation="ALT_TEXT_PAGINATION_PREVIOUS"></span>
          </button>
          <button class="right-btn" [disabled]="(filters.pageNumber ?? 0) >= pagesCount - 1" (click)="nextPage()">
            <img src="assets/icons/pagination-arrow.svg" alt="right">
          </button>
        </div>
      }
    </td>
  </tr>
</tfoot>

</table>

@if (!leadsCount) {
  <div class="empty-message">
    <h2 fiTranslation="SEARCH_MESSAGE_NO_RESULT_HEADLINE"></h2>
    <span fiTranslation="SEARCH_MESSAGE_NO_RESULT_TEXT"></span>
  </div>
}
